import React, { ReactNode } from 'react';
import { Icon, TabButton } from '@pelando/components';
import { useTranslation } from '@/presentation/hooks/useTranslation';
import { Message, Tags } from '@pelando/fontawesome/icons';
import { ProfilePageTabs } from '@/presentation/services/urls/profile';
import { Container, ListContainer, TabsContainer } from './style';

type ProfileTabsProps = {
  commentsTabContent: ReactNode;
  dealsTabContent: ReactNode;
  initialTab?: ProfilePageTabs;
  totalOffers?: number;
  totalComments?: number;
  dealsTabUrl?: string;
  commentsTabUrl?: string;
};

export default function ProfileTabs({
  commentsTabContent,
  dealsTabContent,
  initialTab,
  totalOffers,
  totalComments,
  dealsTabUrl,
  commentsTabUrl,
}: ProfileTabsProps) {
  const { t } = useTranslation('profile');

  const dealsIsActive = initialTab === ProfilePageTabs.Deals;
  const commentIsActive = initialTab === ProfilePageTabs.Comments;

  return (
    <Container>
      <TabsContainer>
        <TabButton url={dealsTabUrl} active={dealsIsActive}>
          <Icon icon={Tags} />
          {totalOffers || 0} {t('profile-tab-deals')}
        </TabButton>
        <TabButton url={commentsTabUrl} active={commentIsActive}>
          <Icon icon={Message} />
          {totalComments || 0} {t('profile-tab-comments')}
        </TabButton>
      </TabsContainer>
      <ListContainer>
        {dealsIsActive && dealsTabContent}
        {commentIsActive && commentsTabContent}
      </ListContainer>
    </Container>
  );
}
